export class State {
    constructor(value) {
        this.value = value;
        this.subscriptors = new Set();
    }
    subscribe(sub) {
        if (!this.subscriptors.has(sub)) {
            this.subscriptors.add(sub);
            sub(this.value);
        }
        return () => this.subscriptors.delete(sub);
    }
    set(value = this.value) {
        this.value = value;
        this.subscriptors.forEach(sub => sub(this.value));
    }
}
